import { SdkMethodPayloadInterface } from "@modules/sdk/methods/SdkMethodPayloadInterface";

import { WISHLISTS_SDK_METHODS } from "../constants";
import { WishlistItemSdkDto } from "../types";

class GetWishlistItemsSdkMethodPayload
    implements SdkMethodPayloadInterface<WishlistItemSdkDto[]>
{
    public readonly methodName: WISHLISTS_SDK_METHODS.GET_WISHLIST_ITEMS;

    constructor(
        public readonly wishlistId: number | null,
        public readonly onSuccess: (result: WishlistItemSdkDto[]) => void,
        public readonly onError: (error: Error) => void
    ) {
        this.methodName = WISHLISTS_SDK_METHODS.GET_WISHLIST_ITEMS;
        this.wishlistId = wishlistId;
        this.onSuccess = onSuccess;
        this.onError = onError;
    }
}

export default GetWishlistItemsSdkMethodPayload;
